import { EventEmitter, Injectable } from '@angular/core';
import { HttpService, Search } from '@docpath/linces-angular-components/common';
import { Observable } from 'rxjs';

import { EndPoints } from '../../../constants/end-points';
import { Alert } from '../models/alert';
import { AssignedRule } from '../models/assigned-rule';
import { MonitoringResult, MonitoringSearch } from '../models/monitoring';
import { ReferenceValues } from '../models/reference-values.';


@Injectable({
    providedIn: 'root'
})
export class MonitoringHttpService {
    readonly relativeUrl = `${EndPoints.ENDPOINT_WEB_API}/${EndPoints.ENDPOINT_MONITORING}`;

    showLoadingTableChanged: EventEmitter<boolean> = new EventEmitter();

    constructor(
        private readonly httpService: HttpService
    ) { }


    getReferenceValues(dgeId: number): Observable<ReferenceValues> {
        return new Observable(observer => {
            this.httpService.get({
                relativeUrl: `${this.relativeUrl}/${EndPoints.ENDPOINT_MONITORING_REFERENCE_VALUES}`,
                queryParameters: { dgeId },
                suscribe: response => {
                    const result = response.result as unknown as ReferenceValues;
                    observer.next(result);
                    observer.complete();
                }
            });
        });

    }

    getMonitoring(search: MonitoringSearch): Observable<MonitoringResult[]> {
        return new Observable(observer => {
            const searchBase64 = btoa(JSON.stringify(search));

            this.httpService.get({
                relativeUrl: `${this.relativeUrl}`,
                queryParameters: { search: searchBase64 },
                suscribe: response => {
                    const result = response.result as unknown as MonitoringResult[];
                    observer.next(result);
                    observer.complete();
                }
            });
        });

    }

    getAlerts(dgeId: number, search: Search, suscribe: (result: Alert[], totalSize: number) => void): void {
        const searchBase64 = btoa(JSON.stringify(search));
        this.showLoadingTableChanged.emit(true);

        this.httpService.get({
            relativeUrl: `${this.relativeUrl}/${EndPoints.ENDPOINT_MONITORING_ALERTS}`,
            queryParameters: { dgeId, search: searchBase64 },
            suscribe: response => {
                const responseBody = response.result as unknown as Search,
                    result = responseBody.result as Alert[],
                    totalSize = responseBody.paginator?.totalSize ?? 0;
                this.showLoadingTableChanged.emit(false);
                suscribe(result, totalSize);
            },
            suscribeOnError: () => {
                this.showLoadingTableChanged.emit(false);
            }
        });
    }

    getAssignedAlertRules(dgeId: number): Observable<AssignedRule[]> {
        return new Observable(observer => {
            this.httpService.get({
                relativeUrl: `${this.relativeUrl}/${EndPoints.ENDPOINT_MONITORING_RULES_ASSIGNMENT}`,
                queryParameters: { dgeId },
                suscribe: response => {
                    const result = response.result as unknown as AssignedRule[];
                    observer.next(result);
                    observer.complete();
                }
            });
        });

    }

    assignAlertRule(dgeId: number, assignedRules: AssignedRule[]): Observable<void> {
        return new Observable(observer => {
            this.httpService.put({ dgeId, assignedRules }, {
                relativeUrl: `${this.relativeUrl}/${EndPoints.ENDPOINT_MONITORING_RULES_ASSIGNMENT}`,
                loading: true,
                suscribe: () => {
                    observer.next();
                    observer.complete();
                },
                toast: 'monitoring.toast.assign-alert-rule-success'
            });
        });
    }

}
